module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "mu-thead"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-761008ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/table/thead.vue
// module id = 458
// module chunks = 1